export const mediaCache = new Map();
export const storeLocalFile = (id, file) => {
    const url = URL.createObjectURL(file);
    mediaCache.set(id, url);
};
export const getLocalUrl = (id) => mediaCache.get(id);
export const clearLocalUrl = (id) => {
    const url = mediaCache.get(id);
    if (url)
        URL.revokeObjectURL(url);
    mediaCache.delete(id);
};
export const clearAllLocalUrls = () => {
    for (const url of mediaCache.values()) {
        URL.revokeObjectURL(url);
    }
    mediaCache.clear();
};
